module.exports = fox._r("images/ad_scroll_back.png", __webpack_public_path__ + "images/ad_scroll_back.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/ad_scroll_back.png
// module id = 973
// module chunks = 4